// import { AddShoppingCartOutlined } from "@mui/icons-material";
// import {
//   Button,
//   Card,
//   CardActions,
//   CardContent,
//   CardMedia,
//   Rating,
//   Typography,
// } from "@mui/material";
// import React from "react";
// import "./ProductCard.css";


// const ProductCard = ({ product, handleAddToCart }) => {
//   return (
//     <Card className="card">
//       <CardMedia component="img" style={{ height: "200px" }} image={product.image} />
//       <CardContent>
//         <Typography color="textPrimary" variant="h6">
//           {product.name}
//         </Typography>
//         <Typography color="textSecondary" variant="subtitle2">
//           ${product.cost}
//         </Typography>
//         <Rating name="read-only" value={product.rating} readOnly />
//       </CardContent>
//       <CardActions className="card-actions">
//         <Button className="card-button" cariant="contained" onClick={handleAddToCart} >
//           <AddShoppingCartOutlined />
//           ADD TO CART
//         </Button>
//       </CardActions>
//     </Card>
//   );
// };

// export default ProductCard;

////////////////////////////////////////////////////////////////////////




import { AddShoppingCartOutlined } from "@mui/icons-material";
import {
  Button,
  Card,
  CardActions,
  CardActionArea,
  CardContent,
  CardMedia,
  Rating,
  Typography,
} from "@mui/material";
import React from "react";
import "./ProductCard.css";

const ProductCard = ({ product, handleAddToCart }) => {
  return (
          <Card className="card">
            <CardActionArea>
              <CardMedia
                component="img"
                height="140"
                image={product.image}
                alt="product"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {product.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  ${product.cost}
                </Typography>
                <Rating name="read-only" value={product.rating} readOnly />
              </CardContent>
            </CardActionArea>
            <CardActions>
              <Button fullWidth={true} color="primary" variant="contained" onClick={handleAddToCart}>
                <AddShoppingCartOutlined />ADD TO CART
              </Button>
            </CardActions>
          </Card>
  );
};

export default ProductCard;
